module.exports = __webpack_public_path__ + "img/cover-light.e5b3aeab.png";